export default {"src":"/polygon/_next/static/media/partner_8.4fc59caf.svg","height":121,"width":180};